/**
 * `/checkout/cancel` — plan 030.
 *
 * Stripe redirects here when the parent closes the checkout tab or
 * clicks the built-in back button. Nothing to clean up on our side; we
 * flash a soft note that the trial is still running and route to the
 * dashboard.
 */

import { useEffect } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { clearCheckoutIntent } from '../state/checkout-intent';
import { setFlash } from '../state/flash';

export function CheckoutCancelRoute() {
  const location = useLocation();

  useEffect(() => {
    setFlash({
      kind: 'checkout-canceled',
      message:
        "Trial started without a card. Add one from Settings whenever you're ready.",
    });
    clearCheckoutIntent();
    location.route('/dashboard');
  }, [location]);

  return null;
}
